import { z } from "zod";
import { schema as tooltipSchema } from "./tooltip";

export const schema = z.object({
  tooltip: tooltipSchema.optional(),
});

export type Chart = z.infer<typeof schema>;
